export const Condicao = {
  7: 'Sucata',
  9: 'Bom',
  10: 'Regular',
  11: 'Ruim',
  12: 'Péssimo'
}

export const StatusArremate = {
  0: 'Condicional/Aguardando liberação',
  1: 'Aprovado',
  2: 'Entregue',
  3: 'Arrematante desistiu',
  4: 'Cancelado'
}

export const STATUS_RASCUNHO = 0
export const STATUS_ABERTO_PARA_LANCES = 1
export const STATUS_EM_PREGAO = 2
export const STATUS_DOULHE_UMA = 3
export const STATUS_DOULHE_DUAS = 4
export const STATUS_HOMOLOGANDO = 5
export const STATUS_VENDIDO = 6
export const STATUS_NAO_PAGO = 7
export const STATUS_NAO_VENDIDO = 8
export const STATUS_RECOMPRA = 9
export const STATUS_RETIRADO = 10
export const STATUS_FECHADO = 11

export const Status = {
  [STATUS_RASCUNHO]: {titulo: 'Rascunho', class: 'light', color: '#FFFFFF', onlyAdm: false},
  [STATUS_ABERTO_PARA_LANCES]: {titulo: 'Aberto', class: 'info', color: '#FFFFFF', onlyAdm: false},
  [STATUS_EM_PREGAO]: {titulo: 'Em Pregão', class: 'orange', color: '#FF7F00', onlyAdm: true},
  [STATUS_DOULHE_UMA]: {titulo: 'Doulhe-uma', class: 'warning', color: '#FFFF00', onlyAdm: true},
  [STATUS_DOULHE_DUAS]: {titulo: 'Doulhe-duas', class: 'warning', color: '#FE2C31', onlyAdm: true},
  [STATUS_HOMOLOGANDO]: {titulo: 'Homologando', class: 'primary', color: '#007FFF', onlyAdm: true},
  [STATUS_VENDIDO]: {titulo: 'Vendido', class: 'success', color: '#7FFF00', onlyAdm: true},
  [STATUS_NAO_PAGO]: {titulo: 'Não Pago', class: 'purple', color: '#FFCC99', onlyAdm: true},
  [STATUS_NAO_VENDIDO]: {titulo: 'Não Vendido', class: 'brown', color: '#FFBFFF', onlyAdm: true},
  [STATUS_RECOMPRA]: {titulo: 'Recompra', class: 'pink', color: '#FD00EE', onlyAdm: true},
  [STATUS_RETIRADO]: {titulo: 'Retirado', class: 'danger', color: 'red', onlyAdm: false},
  [STATUS_FECHADO]: {titulo: 'Fechado', class: 'black', color: 'black', onlyAdm: true}
}

export const StatusTitle = function (s) {
  if (typeof Status[s] === 'undefined') {
    return 'Unknow status code'
  }
  return Status[s].titulo
}

export const StatusTitleColor = function (s, t) {
  t = typeof t !== 'undefined' ? t : 'titulo'
  if (typeof Status[s] === 'undefined') {
    return 'Unknow status code'
  }
  return Status[s][t]
}

export const ESTADOS_LOTE = [
  {value: 1, label: 'VEICULO CONSERVADO SEM MOTOR', parents: [STATUS_RASCUNHO, STATUS_ABERTO_PARA_LANCES, STATUS_NAO_VENDIDO, STATUS_VENDIDO, STATUS_NAO_PAGO]},
  {value: 2, label: 'SUCATA INSERVIVEL IDENTIFICADA', parents: [STATUS_RASCUNHO, STATUS_ABERTO_PARA_LANCES, STATUS_NAO_VENDIDO, STATUS_VENDIDO, STATUS_NAO_PAGO, STATUS_RETIRADO]},
  {value: 3, label: 'SUCATA INSERVIVEL NAO IDENTIFICADA', parents: [STATUS_RASCUNHO, STATUS_ABERTO_PARA_LANCES, STATUS_NAO_VENDIDO, STATUS_VENDIDO, STATUS_NAO_PAGO, STATUS_RETIRADO]},
  {value: 4, label: 'VEICULO CONSERVADO', parents: [STATUS_RASCUNHO, STATUS_ABERTO_PARA_LANCES, STATUS_NAO_VENDIDO, STATUS_VENDIDO, STATUS_NAO_PAGO]},
  {value: 5, label: 'RECOMPRA (LEILAO NAO ENTREGUE)', parents: [STATUS_RASCUNHO, STATUS_RECOMPRA]},
  {value: 6, label: 'RECOMPRA (LEILAO ENTREGUE)', parents: [STATUS_RASCUNHO, STATUS_RECOMPRA]},
  {value: 7, label: 'DESISTENCIA (LEILAO NAO ENTREGUE)', parents: [STATUS_RASCUNHO, STATUS_RECOMPRA]},
  {value: 8, label: 'DESISTENCIA (LEILAO ENTREGUE)', parents: [STATUS_RASCUNHO, STATUS_RECOMPRA]},
  {value: 9, label: 'VEICULO NAO LOCALIZADO', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 10, label: 'PERICIA NAO REALIZADA', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 11, label: 'SEM RETORNO DE NOTIFICACAO', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 12, label: 'PERICIA (CORRIGIR LAUDO)', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 13, label: 'SEM CADASTRO', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 14, label: 'SEM CADASTRO (NÃO RECOLHIDO)', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 15, label: 'SEM CADASTRO (RECOLHIDO DETRAN/STOPLOG/COSTOP)', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 16, label: 'SEM CADASTRO (RECOLHIDO SEOP)', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 17, label: 'SEM CADASTRO (RECOLHIDO OUTRO ORGAO)', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 18, label: 'CARROCERIA NÃO APROVEITÁVEL', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 19, label: 'SEM CADASTRO (VEICULO NAO CADASTRADO 2)', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 20, label: 'SEM CADASTRO (SEM INFORMACAO NO DETRAN)', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 21, label: 'POR PROPRIETÁRIO (BOLETO)', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 22, label: 'PERICIADO SEM PUBLICACAO', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 23, label: 'VEICULO DE ORGAO PUBLICO', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 24, label: 'VEICULO ADULTERADO - ENCAMINHAR DRFA', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 25, label: 'RESTRICAO JUDICIAL', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 26, label: 'RESTRICAO ROUBOS E FURTOS', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 27, label: 'RESTRICAO DETRO', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 28, label: 'RESTRICAO ADMINISTRATIVA', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 29, label: 'SUSPENSO (AGUARDANDO DECISAO JUDICIAL)', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 30, label: 'RESTRICAO ESTELIONATO/AP.INDEB', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 31, label: 'VEICULO NAO PERTENCE A UF.1', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 32, label: 'ESTADO FIS. CADASTRADO EM LEILAO', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 33, label: 'ERRO DE CADASTRO REBOCAR', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 34, label: 'VEICULO ADULTERADO', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 35, label: 'VEDADA A CIRCULAÇÃO', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 36, label: 'APTOS PARA LEILÃO', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 37, label: 'AGUARDANDO RETORNO DE ARG', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]},
  {value: 38, label: 'REPROVADO POR PERÍCIA', parents: [STATUS_RASCUNHO, STATUS_RETIRADO]}
]



// WEBPACK FOOTER //
// ./src/domain/leiloes/helpers/LoteStatus.js